export default "__VITE_ASSET__D5tmAg8w__"